import type { TFunction } from "i18next";
import U2000DeleteRecordDialog from "../../../u2000Core/components/dialog/U2000DeleteRecordDialog";
import type { U2000DeleteHandlersReturn } from "../../../u2000Core/hooks/handler/U2000UseDeleteHandlers";

// Typage des props du composant
interface U3148OrganizationAffiliaitonDeleteDlgProps {
  handleDelete: U2000DeleteHandlersReturn;
  t: TFunction;
  NS: string;
}

function U3148OrganizationAffiliaitionDeleteDlg({ handleDelete, t, NS }: U3148OrganizationAffiliaitonDeleteDlgProps) {
  if (!handleDelete.isDialogDeleteOpen) return null;

  return (
    <U2000DeleteRecordDialog isOpen={handleDelete.isDialogDeleteOpen} onClose={handleDelete.handleDeleteCloseDlg} title={t("lblDeleteDlgTitle", { ns: NS })}>
      <p className="mb-4">
        {t("user.msgDeleteUser", {
          count: handleDelete.selectedRows().length,
          ns: NS,
        })}
      </p>
      <div className="mt-2 flex flex-wrap justify-center gap-x-2">
        {handleDelete.selectedRows().map((row, index, array) => {
          let username = row.username;
          let firstName = row.firstName;
          let lastName = row.lastName;
          if (row.user) {
            username = row.user.username;
            firstName = row.user.firstName;
            lastName = row.user.lastName;
          }
          return (
            <span key={username} className="inline-block text-gray-800">
              {`${username} - ${firstName} ${lastName}`}
              {index < array.length - 1 && ", "}
            </span>
          );
        })}
      </div>
    </U2000DeleteRecordDialog>
  );
}

export default U3148OrganizationAffiliaitionDeleteDlg;
